import { FETCH_EMPLOYEES } from '../actions/Types'
const employeeReducer = (state=[], action) => {
    switch(action.type){
        case FETCH_EMPLOYEES:
            return action.payload
        default:
            return state
    }
}

export default employeeReducer